// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3P7ts","image":"Header_image___kVtb","name":"Header_name__3QWeh","info":"Header_info__18g-G","infoRow":"Header_infoRow__137Om"};